import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import axios from 'axios';
// @mui
import { IconButton, Tooltip } from '@mui/material';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

//
import './navbar.css';

// ----------------------------------------------------------------------

Nav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function Nav({ openNav, onCloseNav }) {
  const { pathname } = useLocation();
  const [beranda, setBeranda] = useState(null);
  const API_URL = process.env.REACT_APP_API;
  const BACKEND_API = process.env.REACT_APP_BE;

  const getBeranda = async () => {
    try {
      await axios.get(`${API_URL}beranda/allBeranda`)
        .then(({ data }) => {
          setBeranda(data?.data[0]?.logo);
          localStorage.setItem("judul", data?.data[0]?.judul);
        })
        .catch((err) => {
          if (err.response.status === 404) { setBeranda([]); }
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getBeranda();
    if (openNav) { onCloseNav(); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const [showNavbar, setShowNavbar] = useState(false);

  const handleShowNavbar = () => {
    setShowNavbar(!showNavbar);
  };

  const navItems = [
    { label: 'Beranda', to: '/beranda' },
    { label: 'Destinasi', to: '/destinasi' },
    { label: 'Pencarian', to: '/pencarian' },
    { label: 'Berita', to: '/berita' },
  ];

  return (
    <div className='sticky'>
      <nav className="navbar">
        <div className="container">
          {/* Logo */}
          <div className="logo">
            {beranda !== null ? (
              <NavLink to='/'>
                <img
                  role='presentation'
                  src={`${BACKEND_API}${beranda}`}
                  className='logos'
                  alt='logo'
                />
              </NavLink>
            ) : (
              <NavLink to='/' style={{
                textDecoration: 'none',
                fontWeight: 800,
                fontSize: '18px',
                color: '#B85C2C',
                fontFamily: "'Plus Jakarta Sans', sans-serif",
              }}>
                Gastronesia
              </NavLink>
            )}
          </div>

          {/* Mobile hamburger */}
          <div
            className="menu-icon"
            onClick={handleShowNavbar}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleShowNavbar(); }}
            role='button'
            tabIndex={0}
            aria-label="Toggle menu"
          >
            {showNavbar
              ? <CloseRoundedIcon style={{ fontSize: 22 }} />
              : <MenuRoundedIcon style={{ fontSize: 22 }} />
            }
          </div>

          {/* Nav Links */}
          <div className={`nav-elements ${showNavbar ? 'active' : ''}`}>
            {showNavbar && (
              <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '8px 12px 0' }}>
                <Tooltip title="Tutup menu">
                  <IconButton
                    onClick={handleShowNavbar}
                    size="small"
                    sx={{
                      color: '#B85C2C',
                      background: 'rgba(184,92,44,0.08)',
                      '&:hover': { background: 'rgba(184,92,44,0.15)' },
                    }}
                  >
                    <CloseRoundedIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </div>
            )}
            <ul>
              {navItems.map((item) => (
                <li key={item.to}>
                  <NavLink
                    to={item.to}
                    onClick={showNavbar ? handleShowNavbar : undefined}
                  >
                    {item.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
}
